<template>
  <div class="form-item">
    <label :for="this.Id">{{this.Label}}</label>
    <div v-if="this.Type === 'textarea'">
      <textarea
        :name="this.Id"
        :id="this.Id"
        :type="this.Type"
        :required="this.Required"
        :disabled="this.Disabled"
        v-model="val"
      />
    </div>
    <div v-else-if="this.Type === 'select'">
      <Select
        :name="this.Id"
        :id="this.Id"
        :options="this.List"
        :required="this.Required"
        :getOptionDescription="getCustomDescription"
        v-model="val"
        option-label="text"
        option-key="id"
      />
    </div>
    <div v-else-if="this.Type === 'checkbox'" class="checkbox">
      <label>
        <input
          :name="this.Id"
          :id="this.Id"
          :type="this.Type"
          :required="this.Required"
          :disabled="this.Disabled"
          v-model="val"
        />
      </label>
    </div>
    <div v-else-if="this.Type === 'checkbox-list'" class="checkbox">
      <ul>
        <li v-for="item in this.list" :key="item.name">
          <input type="checkbox" :id="item.name" :value="item.value" v-model="val" />
          <label :for="item.name">{{item.name}}</label>
        </li>
      </ul>
    </div>
    <div v-else-if="this.Type === 'radio-button-list'" class="checkbox">
      <ul>
        <li v-for="item in this.list" :key="item.name">
          <input type="radio" :id="item.name" :value="item.value" v-model="val" />
          <label :for="item.name">{{item.name}}</label>
        </li>
      </ul>
    </div>
    <div v-else>
      <input
        :name="this.Id"
        :id="this.Id"
        :type="this.Type"
        :disabled="this.Disabled"
        v-model="val"
      />
    </div>
    <label
      v-if="this.IsEmpty"
      :name="'val' + this.Id"
      :id="'val' + this.Id"
      class="text-danger"
    >Este campo es requerido</label>
  </div>
</template>

<script>
import Select from "../Select";

export default {
  name: "FormItem",
  components: { Select },
  data() {
    return {
      internalVal: null
    };
  },
  computed: {
    val: {
      get() {
        return this.internalVal;
      },
      set(value) {
        this.internalVal = value;
        this.$emit("input", this.internalVal);
      }
    }
  },
  props: {
    Type: {
      type: String,
      required: true,
      default: () => "text"
    },
    Id: {
      type: String,
      required: true
    },
    Label: {
      type: String,
      required: true
    },
    Disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    IsEmpty: {
      type: Boolean,
      required: false,
      default: () => false
    },
    List: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    getCustomDescription(opt) {
      return opt.text;
    }
  }
};
</script>